// AuthComplete.tsx
// 본인인증 완료 후 원래 채널(B2B/B2C)의 신청 페이지로 복귀
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const AuthComplete = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const imp_uid = searchParams.get('imp_uid');
    const success = searchParams.get('success') === 'true';
    const channel = searchParams.get('channel');

    // B2C 채널에서 인증한 경우 /dawontrade-in/apply로 복귀
    const applyPath = channel === 'b2c' ? '/dawontrade-in/apply' : '/apply';

    if (success && imp_uid) {
      navigate(`${applyPath}?imp_uid=${imp_uid}&success=true`);
    } else {
      alert('본인인증 실패 또는 취소됨');
      navigate(applyPath);
    }
  }, [navigate, searchParams]);

  return null;
};

export default AuthComplete;
